import Category from "../../../Components/Admin/Category";

const CategoryPage = () => {
  return <Category />;
};

export default CategoryPage;
